import moment from 'moment'
import api from '../../services/service_report'
// import apipos from '../../services/service_pos'
import apiItem from '../../services/service_item'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      host_list: [],
      report_data: [],
      search_text: '',
      host: '',
      now_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: '',
      item_start: '',
      item_end: '',
      item_data: []
    }
  },
  methods: {
    getItems () {
      apiItem.listProduct(
        this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            result.data.forEach(val => {
              this.item_data.push({
                name: val['code'] + ': ' + val['name'],
                code: val['code']
              })
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getReport () {
      var obj = {
        'item_code': '',
        'group_code': ''
      }
      this.$store.commit('Loading')
      api.StandardCostReport(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
            this.form_host = JSON.stringify(this.host)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    count_qty (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_qty']
      })
      return sum
    },
    count_use (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_input']
      })
      return sum
    },
    count_input (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_use']
      })
      return sum
    },
    count_stock (obj) {
      var sum = 0
      obj.forEach((v) => {
        if (v.items) {
          v.items.forEach(val => {
            sum += val['stock_qty']
          })
        }
      })
      return sum
    }
  },
  mounted () {
    // this.getHost()
    // this.getBranch()
    // this.getItems()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_stock_standard.js